'use client';
import { useQuery } from '@tanstack/react-query';
import type { StorefrontCategory } from '@/api/menu-list/storefront-menu-snapshot.types';
import { QueryApi } from '@/features/query/api';
import { CategoriesComponent } from './categories-component';
import { CategoriesProps, CategoryT } from './types';

type Props = Omit<CategoriesProps, 'categories'>;

const mapCategoryRecursively = ({
    id,
    name,
    assets,
    children,
    public: isPublic,
}: StorefrontCategory): CategoryT | null => {
    if (!isPublic) {
        return null;
    }
    return {
        id,
        name,
        iconUrl: assets?.find(({ isMainAsset }) => isMainAsset)?.fullUrl ?? undefined,
        subCategories:
            (children?.map(mapCategoryRecursively).filter((cat) => cat !== null) as CategoryT[]) || [],
    };
};

export const Categories = (props: Props) => {
    const menuLists = useQuery(QueryApi.MenuList.queries.MenuLists);
    const categories: CategoryT[] =
        (menuLists?.data?.menuLists
            .filter((menuList) => menuList.public)
            .flatMap((menuList) => menuList.categories)
            .map(mapCategoryRecursively)
            .filter((cat) => cat !== null) as CategoryT[]) ?? [];

    return <CategoriesComponent {...props} categories={categories} />;
};
